import { IconType } from 'core/components/icons/types'
import React, { useRef } from 'react'
import cn from 'classnames'

import { ReactComponent as ArrowRight } from './svg/arrow-right.svg'
import { ReactComponent as ArrowLeft } from './svg/arrow-left.svg'
import { ReactComponent as Briefcase } from './svg/briefcase.svg'
import { ReactComponent as BriefcaseOutline } from './svg/briefcase-outline.svg'
import { ReactComponent as Car } from './svg/car.svg'
import { ReactComponent as CarOutline } from './svg/car-outline.svg'
import { ReactComponent as Cards } from './svg/cards.svg'
import { ReactComponent as CardsOutline } from './svg/cards-outline.svg'
import { ReactComponent as Calendar } from './svg/calendar.svg'
import { ReactComponent as CalendarOutline } from './svg/calendar-outline.svg'
import { ReactComponent as Categories } from './svg/categories.svg'
import { ReactComponent as CategoriesOutline } from './svg/categories-outline.svg'
import { ReactComponent as Clipboard } from './svg/clipboard.svg'
import { ReactComponent as ClipboardOutline } from './svg/clipboard-outline.svg'
import { ReactComponent as Coins } from './svg/coins.svg'
import { ReactComponent as Deactivated } from './svg/deactivated.svg'
import { ReactComponent as DownloadExcel } from './svg/download-excel.svg'
import { ReactComponent as DownloadExcelOutline } from './svg/download-excel-outline.svg'
import { ReactComponent as DownloadPdf } from './svg/download-pdf.svg'
import { ReactComponent as DownloadPdfOutline } from './svg/download-pdf-outline.svg'
import { ReactComponent as DollarSign } from './svg/dollar-sign.svg'
import { ReactComponent as DoubleArrowLeft } from './svg/double-arrow-left.svg'
import { ReactComponent as DoubleArrowRight } from './svg/double-arrow-right.svg'
import { ReactComponent as EditIcon } from './svg/edit.svg'
import { ReactComponent as EditCircleIcon } from './svg/edit-circle.svg'
import { ReactComponent as ExpenseIcon } from './svg/expense.svg'
import { ReactComponent as ExclamationMark } from './svg/exclamation-mark.svg'
import { ReactComponent as Expand } from './svg/expand.svg'
import { ReactComponent as EyeClosed } from './svg/eye-closed.svg'
import { ReactComponent as EyeOpen } from './svg/eye-open.svg'
import { ReactComponent as FavoritePlace } from './svg/favorite-place.svg'
import { ReactComponent as FavoritePlaceOutline } from './svg/favorite-place-outline.svg'
import { ReactComponent as Gear } from './svg/gear.svg'
import { ReactComponent as GearOutline } from './svg/gear-outline.svg'
import { ReactComponent as GPSOutline } from './svg/gps-outline.svg'
import { ReactComponent as Help } from './svg/help.svg'
import { ReactComponent as HelpOutline } from './svg/help-outline.svg'
import { ReactComponent as Home } from './svg/home.svg'
import { ReactComponent as HomeOutline } from './svg/home-outline.svg'
import { ReactComponent as Integrations } from './svg/integrations.svg'
import { ReactComponent as IntegrationsOutline } from './svg/integrations-outline.svg'
import { ReactComponent as Key } from './svg/key.svg'
import { ReactComponent as KeyOutline } from './svg/key-outline.svg'
import { ReactComponent as PinAndPenOutline } from './svg/pin-and-pen-outline.svg'
import { ReactComponent as PinAndPen } from './svg/pin-and-pen.svg'
import { ReactComponent as Play } from './svg/play.svg'
import { ReactComponent as LogoutOutline } from './svg/logout-outline.svg'
import { ReactComponent as Marker } from './svg/marker.svg'
import { ReactComponent as Map } from './svg/map.svg'
import { ReactComponent as MapOutline } from './svg/map-outline.svg'
import { ReactComponent as MarkerOutline } from './svg/marker-outline.svg'
import { ReactComponent as Minus } from './svg/minus.svg'
import { ReactComponent as Note } from './svg/note.svg'
import { ReactComponent as Person } from './svg/person.svg'
import { ReactComponent as PersonCircle } from './svg/person-circle.svg'
import { ReactComponent as PersonCircleOutline } from './svg/person-circle-outline.svg'
import { ReactComponent as PersonOutline } from './svg/person-outline.svg'
import { ReactComponent as PremiumIcon } from './svg/premium.svg'
import { ReactComponent as Reimbursement } from './svg/reimbursement.svg'
import { ReactComponent as ReimbursementOutline } from './svg/reimbursement-outline.svg'
import { ReactComponent as Report } from './svg/report.svg'
import { ReactComponent as ReportOutline } from './svg/report-outline.svg'
import { ReactComponent as Rules } from './svg/rules.svg'
import { ReactComponent as RulesOutline } from './svg/rules-outline.svg'
import { ReactComponent as Schedule } from './svg/schedule.svg'
import { ReactComponent as ScheduleOutline } from './svg/schedule-outline.svg'
import { ReactComponent as SheetsOutline } from './svg/sheets-outline.svg'
import { ReactComponent as Shop } from './svg/shop.svg'
import { ReactComponent as Summary } from './svg/summary.svg'
import { ReactComponent as SummaryOutline } from './svg/summary-outline.svg'
import { ReactComponent as Star } from './svg/star.svg'
import { ReactComponent as StartOutline } from './svg/star-outline.svg'
import { ReactComponent as SteeringWheel } from './svg/steering-wheel.svg'
import { ReactComponent as Synced } from './svg/synced.svg'
import { ReactComponent as Tag } from './svg/tag.svg'
import { ReactComponent as TagOutline } from './svg/tag-outline.svg'
import { ReactComponent as Tax } from './svg/tax.svg'
import { ReactComponent as TaxOutline } from './svg/tax-outline.svg'
import { ReactComponent as Team } from './svg/team.svg'
import { ReactComponent as TeamOutline } from './svg/team-outline.svg'
import { ReactComponent as Tracker } from './svg/tracker.svg'
import { ReactComponent as TrackerOutline } from './svg/tracker-outline.svg'
import { ReactComponent as Transaction } from './svg/transaction.svg'
import { ReactComponent as TransactionOutline } from './svg/transaction-outline.svg'
import { ReactComponent as Trip } from './svg/trip.svg'
import { ReactComponent as TripOutline } from './svg/trip-outline.svg'
import { ReactComponent as Trash } from './svg/trash.svg'
import { ReactComponent as TrashOutline } from './svg/trash-outline.svg'
import { ReactComponent as Question } from './svg/question.svg'
import { ReactComponent as Upload } from './svg/upload.svg'
import { ReactComponent as UploadCsv } from './svg/upload-csv.svg'
import { ReactComponent as UploadCsvOutline } from './svg/upload-csv-outline.svg'
import { ReactComponent as UploadOutline } from './svg/upload-outline.svg'
import { ReactComponent as Vehicle } from './svg/vehicle.svg'
import { ReactComponent as VehicleOutline } from './svg/vehicle-outline.svg'
import { ReactComponent as Wallet } from './svg/wallet.svg'
import { ReactComponent as WalletOutline } from './svg/wallet-outline.svg'
import { ReactComponent as Work } from './svg/work.svg'
import { ReactComponent as WorkOutline } from './svg/work-outline.svg'
import { ReactComponent as Close } from './svg/close.svg'
import { ReactComponent as Check } from './svg/check.svg'
import { ReactComponent as Down } from './svg/down.svg'
import { ReactComponent as Download } from './svg/download.svg'
import { ReactComponent as Filter } from './svg/filter.svg'
import { ReactComponent as FilterOutline } from './svg/filter-outline.svg'
import { ReactComponent as Left } from './svg/left.svg'
import { ReactComponent as LightBulb } from './svg/light-bulb.svg'
import { ReactComponent as Lock } from './svg/lock.svg'
import { ReactComponent as LockOutline } from './svg/lock-outline.svg'
import { ReactComponent as Loading } from './svg/loading.svg'
import { ReactComponent as Right } from './svg/right.svg'
import { ReactComponent as Up } from './svg/up.svg'
import { ReactComponent as Link } from './svg/link.svg'
import { ReactComponent as Grip } from './svg/grip.svg'
import { ReactComponent as MoreVertical } from './svg/more-vertical.svg'
import { ReactComponent as MoreHorizontal } from './svg/more-horizontal.svg'
import { ReactComponent as NoteOutline } from './svg/note-outline.svg'
import { ReactComponent as Search } from './svg/search.svg'
import { ReactComponent as SearchEmpty } from './svg/search-empty.svg'
import { ReactComponent as Share } from './svg/share.svg'
import { ReactComponent as ShopOutline } from './svg/shop-outline.svg'
import { ReactComponent as RoundTrip } from './svg/round-trip.svg'
import { ReactComponent as CalculateRoute } from './svg/calculate-route.svg'
import { ReactComponent as WalletWithBill } from './svg/wallet-with-bill-.svg'
import { ReactComponent as WalletWithBillOutline } from './svg/wallet-with-bill-outline.svg'
import { ReactComponent as Flag } from './svg/flag.svg'
import { ReactComponent as Sort } from './svg/sort.svg'
import { ReactComponent as FlagOutline } from './svg/flag-outline.svg'
import { ReactComponent as Heart } from './svg/heart.svg'
import { ReactComponent as Photo } from './svg/photo.svg'
import { ReactComponent as PhotoOutline } from './svg/photo-outline.svg'
import { ReactComponent as Clock } from './svg/clock.svg'
import { ReactComponent as ClockOutline } from './svg/clock-outline.svg'
import { ReactComponent as CheckCircle } from './svg/check-circle.svg'
import { ReactComponent as CloseCircle } from './svg/close-circle.svg'
import { ReactComponent as CheckCircleOutline } from './svg/check-circle-outline.svg'
import { ReactComponent as CloseCircleOutline } from './svg/close-circle-outline.svg'
import { ReactComponent as Plus } from './svg/plus.svg'
import { ReactComponent as ArrowUp } from './svg/arrow-up.svg'
import { ReactComponent as Info } from './svg/info.svg'
import { ReactComponent as Open } from './svg/open.svg'
import { ReactComponent as PersonCheckOutline } from './svg/person-check-outline.svg'

const Icons: Record<IconType, JSX.Element> = {
  'arrow-right': <ArrowRight />,
  'arrow-left': <ArrowLeft />,
  'arrow-up': <ArrowUp />,
  briefcase: <Briefcase />,
  'briefcase-outline': <BriefcaseOutline />,
  car: <Car />,
  'car-outline': <CarOutline />,
  cards: <Cards />,
  'cards-outline': <CardsOutline />,
  calendar: <Calendar />,
  'calendar-outline': <CalendarOutline />,
  categories: <Categories />,
  'categories-outline': <CategoriesOutline />,
  clipboard: <Clipboard />,
  'clipboard-outline': <ClipboardOutline />,
  close: <Close />,
  check: <Check />,
  down: <Down />,
  download: <Download />,
  'dollar-sign': <DollarSign />,
  'double-arrow-left': <DoubleArrowLeft />,
  'double-arrow-right': <DoubleArrowRight />,
  edit: <EditIcon />,
  'edit-circle': <EditCircleIcon />,
  expense: <ExpenseIcon />,
  'exclamation-mark': <ExclamationMark />,
  expand: <Expand />,
  'eye-closed': <EyeClosed />,
  'eye-open': <EyeOpen />,
  coins: <Coins />,
  deactivated: <Deactivated />,
  'download-excel': <DownloadExcel />,
  'download-excel-outline': <DownloadExcelOutline />,
  'download-pdf': <DownloadPdf />,
  'download-pdf-outline': <DownloadPdfOutline />,
  'favorite-place': <FavoritePlace />,
  'favorite-place-outline': <FavoritePlaceOutline />,
  flag: <Flag />,
  'flag-outline': <FlagOutline />,
  filter: <Filter />,
  'filter-outline': <FilterOutline />,
  gear: <Gear />,
  'gear-outline': <GearOutline />,
  'gps-outline': <GPSOutline />,
  grip: <Grip />,
  help: <Help />,
  'help-outline': <HelpOutline />,
  home: <Home />,
  'home-outline': <HomeOutline />,
  integrations: <Integrations />,
  'integrations-outline': <IntegrationsOutline />,
  key: <Key />,
  'key-outline': <KeyOutline />,
  left: <Left />,
  'light-bulb': <LightBulb />,
  link: <Link />,
  lock: <Lock />,
  'lock-outline': <LockOutline />,
  loading: <Loading />,
  'pin-and-pen-outline': <PinAndPenOutline />,
  'pin-and-pen': <PinAndPen />,
  play: <Play />,
  'logout-outline': <LogoutOutline />,
  map: <Map />,
  'map-outline': <MapOutline />,
  marker: <Marker />,
  'marker-outline': <MarkerOutline />,
  minus: <Minus />,
  'more-horizontal': <MoreHorizontal />,
  'more-vertical': <MoreVertical />,
  note: <Note />,
  'note-outline': <NoteOutline />,
  person: <Person />,
  'person-circle': <PersonCircle />,
  'person-circle-outline': <PersonCircleOutline />,
  'person-outline': <PersonOutline />,
  right: <Right />,
  premium: <PremiumIcon />,
  reimbursement: <Reimbursement />,
  'reimbursement-outline': <ReimbursementOutline />,
  report: <Report />,
  'report-outline': <ReportOutline />,
  rules: <Rules />,
  'rules-outline': <RulesOutline />,
  schedule: <Schedule />,
  'schedule-outline': <ScheduleOutline />,
  search: <Search />,
  'search-empty': <SearchEmpty />,
  share: <Share />,
  'sheets-outline': <SheetsOutline />,
  shop: <Shop />,
  'shop-outline': <ShopOutline />,
  summary: <Summary />,
  'summary-outline': <SummaryOutline />,
  star: <Star />,
  'star-outline': <StartOutline />,
  'steering-wheel': <SteeringWheel />,
  synced: <Synced />,
  tag: <Tag />,
  'tag-outline': <TagOutline />,
  tax: <Tax />,
  'tax-outline': <TaxOutline />,
  team: <Team />,
  'team-outline': <TeamOutline />,
  tracker: <Tracker />,
  'tracker-outline': <TrackerOutline />,
  transaction: <Transaction />,
  'transaction-outline': <TransactionOutline />,
  trip: <Trip />,
  'trip-outline': <TripOutline />,
  trash: <Trash />,
  'trash-outline': <TrashOutline />,
  question: <Question />,
  up: <Up />,
  upload: <Upload />,
  'upload-csv': <UploadCsv />,
  'upload-csv-outline': <UploadCsvOutline />,
  'upload-outline': <UploadOutline />,
  vehicle: <Vehicle />,
  'vehicle-outline': <VehicleOutline />,
  work: <Work />,
  'work-outline': <WorkOutline />,
  'round-trip': <RoundTrip />,
  'calculate-route': <CalculateRoute />,
  wallet: <Wallet />,
  'wallet-outline': <WalletOutline />,
  'wallet-with-bill': <WalletWithBill />,
  'wallet-with-bill-outline': <WalletWithBillOutline />,
  sort: <Sort />,
  heart: <Heart />,
  photo: <Photo />,
  'photo-outline': <PhotoOutline />,
  clock: <Clock />,
  'clock-outline': <ClockOutline />,
  'check-circle': <CheckCircle />,
  'close-circle': <CloseCircle />,
  'check-circle-outline': <CheckCircleOutline />,
  'close-circle-outline': <CloseCircleOutline />,
  plus: <Plus />,
  info: <Info />,
  open: <Open />,
  'person-check-outline': <PersonCheckOutline />
}
const Icon = ({
  name,
  height = 16,
  width = 16,
  size,
  className = '',
  id,
  color,
  noWrapper = false,
  onClick,
  onMouseDown
}: {
  name: `${IconType}`
  width?: string | number
  height?: string | number
  size?: string | number
  className?: string
  id?: string
  color?: string
  noWrapper?: boolean
  onClick?: React.MouseEventHandler<HTMLSpanElement>
  onMouseDown?: React.MouseEventHandler<HTMLSpanElement>
}) => {
  const svgRef = useRef<SVGSVGElement>(null)
  const Element = Icons[name]

  const loadingStyle = name === 'loading' && 'animate-spin'

  // This is to not crash the app when passing a wrong icon name when showing it dynamically
  if (!Element) return null

  if (noWrapper) {
    return (
      <>
        {React.cloneElement(Element, {
          height: size ? size : height,
          width: size ? size : width,
          id: id,
          className: cn([className, color, loadingStyle]),
          ref: svgRef,
          onClick: onClick ?? undefined,
          onMouseDown: onMouseDown ?? undefined
        })}
      </>
    )
  }

  return (
    <span
      id={id}
      className={cn([className, 'flex items-center justify-center'])}
      onClick={onClick ?? undefined}
      onMouseDown={onMouseDown ?? undefined}
    >
      {React.cloneElement(Element, {
        height: size ? size : height,
        width: size ? size : width,
        className: cn(['transition-colors', color, loadingStyle]),
        ref: svgRef
      })}
    </span>
  )
}

export default Icon
